module.exports = __webpack_public_path__ + "static/media/login4.bf56a7fd.svg";